// extracted by mini-css-extract-plugin
export default {"container":"EntityLink_container__JS65b","iconContainer":"EntityLink_iconContainer__Aysh6","icon":"EntityLink_icon__SerOQ","link":"EntityLink_link__KRp0M"};